import { useAppSelector } from '../../../Hooks/useAppSelector'
import { LabContactsSelectors } from '../StoreAdapter'

export const useLabContactSelector = (labContactId: string) => {
  return useAppSelector((state) =>
    LabContactsSelectors.selectById(state, labContactId),
  )
}
